export default "__VITE_ASSET__oL81ac5N__"